export default __webpack_public_path__ + "static/media/eggslut.b44d82e0.jpeg";